var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading
    ? _c("div", { staticClass: "bg-black" })
    : this.outageBannerExist
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "outage_alert",
            style: _vm.outageBannerColor,
            on: { click: _vm.showOutageDetails }
          },
          [
            _c("div", { staticClass: "container" }, [
              this.outages.length > 1
                ? _c(
                    "span",
                    [
                      _c("font-awesome-icon", {
                        key: _vm.index,
                        staticClass: "chevron-left-icon fa-lg",
                        attrs: { icon: ["fas", "chevron-left"] },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.handleNavigation(
                              _vm.CONSTANTS.LEFT_NAVIGATION
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", [
                !this.outageColor.includes(_vm.CONSTANTS.OUTAGE_BANNER_GREEN)
                  ? _c("img", {
                      staticClass: "mr-2",
                      style: _vm.imageBackgroundStyle,
                      attrs: { src: _vm.outageIcon, alt: "" }
                    })
                  : _vm._e(),
                _vm._v("\n      " + _vm._s(this.outageTitle) + "\n      ")
              ]),
              _vm._v(" "),
              this.outages.length > 1
                ? _c(
                    "span",
                    [
                      _c("font-awesome-icon", {
                        key: _vm.index,
                        staticClass: "chevron-right-icon fa-lg",
                        attrs: { icon: ["fas", "chevron-right"] },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.handleNavigation(
                              _vm.CONSTANTS.RIGHT_NAVIGATION
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3762a46c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3762a46c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/OutageBannerCard.vue
// module id = null
// module chunks = 